<template>
    <AppJumbotron without-tyres>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
            <div>
                <h1 class="text-white mb-4 text-3xl lg:text-4xl xl:text-5xl tracking-wide">
                    Find reviews for
                    <span class="font-bold">{{ manufacturer.name }} {{ model.name }} tyres</span>
                    at {{ config.name }}
                </h1>


                <p class="text-white mb-4">
                    <span class="font-bold inline-block md:block">{{ model.reviews_count }} reviews</span>
                    for {{ manufacturer.name }} {{ model.name }} tyres
                </p>

                <AppButton @click="scrollToRef('latest-reviews')"
                           v-if="model.reviews_count > 0"
                           theme="secondary">
                    Read Reviews
                </AppButton>
            </div>
            <div v-if="model.image" class="hidden md:block">
                <img class="max-h-60 lg:max-h-80" :src="model.image">
            </div>
        </div>
    </AppJumbotron>

    <AppContainer>
        <div class="grid grid-col-1 lg:grid-cols-2 gap-4">
            <div>
                <HighestRatedModelTyres :manufacturer="manufacturer"
                                        :model="model"
                                        :products="products"></HighestRatedModelTyres>
            </div>

            <div class="col-start-1 lg:col-start-2" v-if="topReviews.length > 0">
                <TopModelReviews :manufacturer="manufacturer" :model="model" :reviews="topReviews"></TopModelReviews>
            </div>
        </div>

        <LatestModelReviews ref="latest-reviews"
                            class="mt-8"
                            :manufacturer="manufacturer"
                            :model="model"></LatestModelReviews>

        <ModelPriceRangeTyres :manufacturer="manufacturer" :model="model" price-range="premium"></ModelPriceRangeTyres>

        <ModelPriceRangeTyres :manufacturer="manufacturer"
                              :model="model"
                              price-range="mid-range"></ModelPriceRangeTyres>

        <ModelPriceRangeTyres :manufacturer="manufacturer" :model="model" price-range="budget"></ModelPriceRangeTyres>
    </AppContainer>

    <!--    <AppContainer v-else>-->
    <!--        <p class="py-16 text-center">-->
    <!--            We don't have any tyre reviews associated with {{ manufacturer.name }} {{ model.name }} on record.-->
    <!--        </p>-->
    <!--    </AppContainer>-->
</template>

<script>
import {Head} from "@inertiajs/inertia-vue3";
import AppContainer from "@/Layouts/AppContainer";
import AppJumbotron from "@/Components/AppJumbotron";
import AppButton from "@/Components/AppButton";
import HighestRatedModelTyres from "@/Components/Models/HighestRatedModelTyres";
import TopModelReviews from "@/Components/Models/TopModelReviews";
import LatestModelReviews from "@/Components/Models/LatestModelReviews";
import TyreCard from "@/Components/Products/Tyres/TyreCard";
import ModelCategoryTyres from "@/Components/Models/ModelPriceRangeTyres";
import Scroll from "@/Mixins/Utilities/Scroll";
import ModelPriceRangeTyres from "@/Components/Models/ModelPriceRangeTyres";
import AppHead from "@/Components/AppSeoTags";

export default {
    mixins: [Scroll],
    components: {
        AppHead,
        ModelPriceRangeTyres,
        TyreCard,
        LatestModelReviews,
        TopModelReviews,
        HighestRatedModelTyres,
        AppContainer,
        AppButton,
        AppJumbotron,
        Head
    },
    props: {
        manufacturer: Object,
        model: Object,
        seoTags: Object,
        products: Array,
        topReviews: Array,
        config: Object
    },
    computed: {},
    methods: {}
};
</script>

<style scoped>

</style>
